export const MOCK_DATA = {
    users: [
        { id: 1, name: 'Собственник (Demo)', role: 'admin', fio: 'Иван Иванов', telegram_id: '12345', profit_percentage: 50, share_percent: 50 },
        { id: 2, name: 'Партнер (Demo)', role: 'partner', fio: 'Петр Петров', telegram_id: '67890', profit_percentage: 50, share_percent: 50 },
        { id: 3, name: 'Менеджер (Demo)', role: 'employee', fio: 'Сидор Сидоров', telegram_id: '11111', profit_percentage: 0, share_percent: 0 }
    ],
    wallets: [
        { id: 1, name: 'Тестовый Банк (RUB)', balance: 540000, owner_id: 1, share_percent: 0 },
        { id: 2, name: 'Сейф Офис', balance: 125000, owner_id: 1, share_percent: 0 },
        { id: 3, name: 'USDT (Tether)', balance: 15300, owner_id: 2, share_percent: 0 }
    ],
    projects: [
        { id: 1, name: 'Строительство ЖК "Север"', status: 'В работе', is_archived: false },
        { id: 2, name: 'Ребрендинг Сайта', status: 'В работе', is_archived: false },
        { id: 3, name: 'Маркетинг 2024', status: 'В работе', is_archived: false },
        { id: 4, name: 'Старый Проект', status: 'Завершен', is_archived: true }
    ],
    transactions: [
        { id: 101, date: new Date().toISOString(), type: 'Доход', amount: 500000, wallet_id: 2, category: 'Аванс от клиента', notes: 'Предоплата за ЖК', project_id: 1, created_by: 1 },
        { id: 102, date: new Date(Date.now() - 86400000).toISOString(), type: 'Расход', amount: 25000, wallet_id: 1, category: 'Зарплата', notes: 'Выплата авансов', project_id: 1, created_by: 1 },
        { id: 103, date: new Date(Date.now() - 172800000).toISOString(), type: 'Доход', amount: 150000, wallet_id: 2, category: 'Услуги', notes: 'Оплата за дизайн', project_id: 2, created_by: 1 },
        { id: 104, date: new Date(Date.now() - 259200000).toISOString(), type: 'Расход', amount: 5000, wallet_id: 3, category: 'Сервисы', notes: 'Оплата хостинга', project_id: 2, created_by: 1 }
    ],
    tasks: [
        { id: 1, title: 'Согласовать смету', status: 'В работе', deadline: new Date(Date.now() + 86400000 * 2).toISOString(), priority: 'High', project_name: 'Строительство ЖК "Север"', assignee_id: 1 },
        { id: 2, title: 'Закупить материалы', status: 'В ожидании', deadline: new Date(Date.now() + 86400000 * 5).toISOString(), priority: 'Medium', project_name: 'Строительство ЖК "Север"', assignee_id: 2 },
        { id: 3, title: 'Подготовить отчет', status: 'В работе', deadline: new Date(Date.now() + 86400000).toISOString(), priority: 'Critical', project_name: 'Ребрендинг Сайта', assignee_id: 1 }
    ],
    categories: [
        { id: 1, name: 'Зарплата', type: 'Расход' },
        { id: 2, name: 'Аренда', type: 'Расход' },
        { id: 3, name: 'Продажи', type: 'Доход' },
        { id: 4, name: 'Услуги', type: 'Доход' },
        { id: 5, name: 'Маркетинг', type: 'Расход' },
        { id: 6, name: 'Прочее', type: 'Расход' }
    ],
    settings: {}, // Эмпусто для демо
    logs: [
        { id: 1, timestamp: new Date().toISOString(), user_id: 1, action: 'Login', details: 'Вход в демо режим' }
    ],
    planning: [
        { id: 1, name: 'Оплата налогов', amount: 120000, due_date: new Date(Date.now() + 86400000 * 5).toISOString(), type: 'Расход', frequency: 'Ежеквартально' },
        { id: 2, name: 'Поступление от ООО "Вектор"', amount: 450000, due_date: new Date(Date.now() + 86400000 * 2).toISOString(), type: 'Доход', frequency: 'Одноразово' }
    ],
    inventory: [
        { id: 1, name: 'MacBook Pro 16 M3', quantity: 2, unit: 'шт', price: 250000, location: 'Офис, Склад А' },
        { id: 2, name: 'Монитор Dell 27"', quantity: 5, unit: 'шт', price: 35000, location: 'Офис, Open Space' }
    ],
    clients: [
        { id: 1, name: 'ООО "ГлавСтрой"', info: 'Крупный застройщик, основной заказчик.', telegram_chat_id: '', notify_payment: false, notify_progress: false, notify_materials: false },
        { id: 2, name: 'ИП Сидоров', info: 'Частные заказы по дизайну.', telegram_chat_id: '', notify_payment: false, notify_progress: false, notify_materials: false }
    ],
    products: [
        { id: 1, name: 'Разработка сайта', unit: 'шт', price: 150000, parent_id: null },
        { id: 2, name: 'SEO продвижение', unit: 'мес', price: 30000, parent_id: null },
        { id: 3, name: 'Ведение соцсетей', unit: 'мес', price: 25000, parent_id: null },
        { id: 4, name: 'Дизайн логотипа', unit: 'шт', price: 45000, parent_id: null },
        { id: 10, name: 'Старт (Пакет)', price: 50000, parent_id: null },
        { id: 11, name: 'SEO Опция', price: 5000, parent_id: 10 },
        { id: 12, name: 'SMM Опция', price: 5000, parent_id: 10 },
        { id: 20, name: 'Бизнес (Пакет)', price: 200000, parent_id: null },
        { id: 21, name: 'Комплексный аудит', price: 20000, parent_id: 20 }
    ],
    invoices: [
        { id: 1, number: 'INV-001', client_id: 1, client_name: 'ООО "ГлавСтрой"', project_id: 1, project_name: 'Строительство ЖК "Север"', amount: 500000, paid_amount: 200000, due_date: new Date(Date.now() + 86400000 * 10).toISOString(), type: 'постоянный', status: 'Частично', notes: '' },
        { id: 2, number: 'INV-002', client_id: 2, client_name: 'ИП Сидоров', project_id: 2, project_name: 'Ребрендинг Сайта', amount: 150000, paid_amount: 150000, due_date: new Date(Date.now() - 86400000 * 5).toISOString(), type: 'одноразовый', status: 'Оплачен', notes: '' },
        { id: 3, number: 'INV-003', client_id: 1, client_name: 'ООО "ГлавСтрой"', project_id: 3, project_name: 'Маркетинг 2024', amount: 75000, paid_amount: 0, due_date: new Date(Date.now() + 86400000 * 3).toISOString(), type: 'срочный', status: 'Ожидает', notes: '' }
    ]
};
